// src/utils/publicPaths.js
//
// Single source of truth for "routes a signed-out visitor is meant to be
// able to load". Used by:
//   * api/axiosBoot.js  — a 401 from a background call on one of these
//     pages must not bounce the visitor to /login.
//   * api/client.js     — same, for the canonical axios instance.
//   * hooks/useSessionTimeout.js — the 60-min inactivity redirect must
//     never fire on a public page (e.g. /about is a marketing page, not a
//     tenant surface — it should never navigate to
//     /login?returnTo=%2Fabout).
//
// Matched as prefixes against window.location.pathname.

export const PUBLIC_PATH_PREFIXES = [
  '/about',            // /about, /about-me — the Download landing page
  '/download',
  '/login',
  '/logout',
  '/owneradd',
  '/ownerlogin',
  '/tenantadd',
  '/termsofuse',
  '/privacypolicy',
  '/reset-password',
  '/external-upload/',
  '/e/',               // public event landing pages
  '/ev/',              // first-class public event pages (On-Screen 2.0)
  '/tickets/',         // public ticketing surfaces
];

export function isPublicPath(pathname) {
  const p = pathname || '/';
  if (p === '/') return true;
  return PUBLIC_PATH_PREFIXES.some((prefix) => p === prefix || p.startsWith(prefix));
}
